var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBusiness = function SvgBusiness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "currentColor",
    style: {
      color: "#6a89a6"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.166 3.335a.665.665 0 1 0 0 1.33h2.667a.665.665 0 1 0 0-1.33H6.166ZM6.166 6.002a.665.665 0 1 0 0 1.33h2.667a.665.665 0 1 0 0-1.33H6.166ZM6.166 8.668a.665.665 0 1 0 0 1.33h2.667a.665.665 0 1 0 0-1.33H6.166ZM6.166 11.335a.665.665 0 1 0 0 1.33h2.667a.665.665 0 0 0 0-1.33H6.166Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.165 2.667v2.668h.668a1.998 1.998 0 0 1 1.998 1.998v6a1.998 1.998 0 0 1-1.998 1.998H2.166a1.998 1.998 0 0 1-1.998-1.998v-4a1.998 1.998 0 0 1 1.998-1.998h.669V2.667A1.998 1.998 0 0 1 4.833.668h5.333a1.998 1.998 0 0 1 1.999 1.999ZM4.36 2.194a.668.668 0 0 1 .473-.196h5.333a.668.668 0 0 1 .669.669V14h-6.67V2.668c0-.178.07-.348.195-.473Zm7.805 11.807V6.665h.668a.669.669 0 0 1 .668.668v6a.668.668 0 0 1-.668.668h-.668ZM2.166 8.665h.669v5.337h-.669a.668.668 0 0 1-.668-.669v-4a.668.668 0 0 1 .668-.668Z",
    clipRule: "evenodd"
  })));
};
export default SvgBusiness;